<script setup>
    import { onMounted, reactive, toRefs } from 'vue'
    import { useRoute, useRouter } from 'vue-router/composables'
    import {getActivityLists} from '../api/index'
    import moment from 'moment'

    const router = useRouter()


    const state = reactive({
        lists:[],
        detail:{},
        total:0,
        page:1,
        pageSize:10,
    })


    // 获取列表
    const getLists = ()=>{
        const data={
            pageNo:state.page,
            pageSize:state.pageSize,
        }
         getActivityLists(data).then(({data})=>{
            const _data = data?.list || []
            console.log(_data,99)
            _data.forEach(item => {
                // 开始时间
                item.beginTime = moment(item.beginTime).format('YYYY-MM-DD')
                // 结束时间
                item.endTime = moment(item.endTime).format('YYYY-MM-DD')
            })



            state.lists = _data
            state.detail = _data[0] || {}
            state.total = data.total
        })
    }

    // 分页页数更改的时候
    const handleCurrentChange =(val)=>{
        state.page = val
        getLists()
    }

    const handleClick =(item)=>{
        if(item.wechatUrl){
            window.open(item.wechatUrl,'_blank')
        }else {
            state.detail = item
        }
    }

    const {lists,detail,total,page} = toRefs(state)


    onMounted(() => {

     getLists()

    })

</script>


<template>
    <div>
        <div v-if="detail.id" class="active-box">
            <div class="container active-content flex flex-space-between">
                <img :src="detail.cover" />
                <div class="active-content-text">
                    <p  class="line-clamp1">{{ detail.description }}</p>

                </div>
                <div class="active-content-date">
                    <p>{{ detail.beginTime}}~{{ detail.endTime }}</p>
                </div>
            </div>
        </div>
        <!--   活动列表     -->
        <div >
             <div v-if="lists.length < 1">
                暂无数据~
            </div>
            <ul>
                <li v-for="item in lists" :key="item.id" @click="handleClick(item)">
                    <img :src="item.cover" alt="" srcset="">
                    <p class="line-clamp1">{{ item.title }}</p>
                    <p>{{ item.beginTime}}~{{ item.endTime }}</p>
                </li>
            </ul>
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<style scoped lang="scss">
.active-box{
    padding: 43px 0;
    background: #e5e5e5;
}
.active-content{

    img{
        width: 530px;
        height: 331px;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    }
    .active-content-text{
        color:#202020;
        font-size:18px;
        width: 357px;
        text-align: left;
        p{
            margin-bottom: 34px;
            &:last-child{
                margin-bottom: 0 !important;
            }
        }
    }
    &-date{
        p{
            margin-bottom: 34px;
            &:last-child{
                margin-bottom: 0 !important;
            }
        }
    }
}

ul{
    display: grid;
    grid-template-columns: repeat(3, 355px);
    gap: 58px;
    margin:32px auto;
    justify-content: center;
    li{
        box-sizing: border-box;
        //padding-bottom: 55px;
        cursor: pointer;
        img{
            width: 329px;
            height: 206px;
            box-shadow:0px 3px 6px rgba(0, 0, 0, 0.16);
        }
        p{
            color:#202020;
            font-size:18px;
            margin-top: 12px;
        }

    }
}
.pagination{
    text-align: center;
    margin:30px auto;
}
</style>
